import { Controller } from "@hotwired/stimulus";
import { isInputFilled, isPasswordValid } from "../utils/misc";
import { INVALID_INPUT_CLASS_NAME } from "../utils/constants";

export default class extends Controller {
  static targets = ["passwordInput", "newPasswordConfirmationInput", "newPasswordInput", "otpInput"];

  validatePasswordUpdateForm(e) {
    if (!isInputFilled(this.passwordInputTarget)) {
      e.preventDefault();
      this._displayInvalidInput(this.passwordInputTarget);
    }

    [this.newPasswordInputTarget, this.newPasswordConfirmationInputTarget].forEach((input) => {
      if (!isPasswordValid(input.value)) {
        e.preventDefault();
        this._displayInvalidInput(input);
      }
    });

    if (this.hasOtpInputTarget && !isInputFilled(this.otpInputTarget)) {
      e.preventDefault();
      this._displayInvalidInput(this.otpInputTarget);
    }
  }

  resetInputValidity(e) {
    e.currentTarget.classList.remove(INVALID_INPUT_CLASS_NAME);
  }

  _displayInvalidInput(input) {
    input.classList.add(INVALID_INPUT_CLASS_NAME);
  }
}
